import { Divider, Flex } from '@chakra-ui/react'
import { faAmazon } from '@fortawesome/free-brands-svg-icons'
import { faShop } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { ProductItemInput } from 'types/graphql'

import Icon from 'src/components/widgets/Icon/Icon'
import { toast } from 'src/components/widgets/Toaster/Toaster'
import {
  ItListItemAnalyticsProps,
  useAnalytics,
} from 'src/lib/hooks/analytics/useAnalytics'
import { enforceHttps } from 'src/lib/utils'

import { PromoCodeInfo } from '../..'

const ProductLinkButton = ({
  brandColor,
  product,
  directUrl,
  trackingData,
  promoCodeInfo,
}: {
  brandColor?: string
  product: ProductItemInput
  directUrl?: string
  trackingData: ItListItemAnalyticsProps
  promoCodeInfo?: PromoCodeInfo
}) => {
  const { track } = useAnalytics()
  const onClick = React.useCallback(async () => {
    const openDirectUrl = () => window.open(enforceHttps(directUrl), '_blank')
    track({ eventName: 'ItList Product Item Clicked', props: trackingData })
    if (directUrl) {
      if (product?.promoCodeCode && product?.promoCodeDiscount) {
        navigator.clipboard.writeText(product.promoCodeCode)

        toast('success', 'Promo Code copied!', undefined, { duration: 700 })

        setTimeout(openDirectUrl, 700)
      } else {
        openDirectUrl()
      }
    } else {
      window.open(enforceHttps(product.amazonUrl), '_blank')
    }
  }, [
    track,
    trackingData,
    directUrl,
    product.promoCodeCode,
    product.promoCodeDiscount,
    product.amazonUrl,
  ])
  const hasPromoCode =
    directUrl && promoCodeInfo?.hasCode && promoCodeInfo.currentlyValid

  return (
    <>
      {!hasPromoCode && <Divider />}
      <Flex
        borderRadius={0}
        p={4}
        alignItems="center"
        justifyContent="stretch"
        _hover={{ filter: 'brightness(0.97)' }}
        bg={hasPromoCode ? brandColor : 'white'}
        color={hasPromoCode ? 'white' : 'onyx'}
        onClick={onClick}
        className="body-small-emphasis"
        transition="all 0.2s ease"
        cursor="pointer"
      >
        <Flex
          flex="1 0 auto"
          data-testid={`itemCard-buy${directUrl ? 'Direct' : 'Amazon'}Button`}
        >
          <Icon
            icon={directUrl ? faShop : faAmazon}
            mr={2}
            boxSize="20px"
            color={hasPromoCode ? 'white' : directUrl ? brandColor : 'onyx'}
          />
          {directUrl ? `Shop Direct` : 'Shop on Amazon'}
        </Flex>
        {hasPromoCode && (
          <Flex
            flexDir="column"
            flexWrap="wrap"
            className="input-label"
            ml={4}
            textAlign="right"
          >
            {`${product.promoCodeCode} ${
              product.promoCodeDiscount && ' • ' + product.promoCodeDiscount
            }`}
          </Flex>
        )}
        <Icon
          icon={faChevronRight}
          fontSize="16px"
          ml={2}
          color={hasPromoCode ? undefined : 'graphite'}
        />
      </Flex>
    </>
  )
}
export default ProductLinkButton
